// extracted by mini-css-extract-plugin
module.exports = {"Report":"Report_Report__3aiKa","Counter":"Report_Counter__2U1O7"};